import React, { Component } from "react";
import { Button } from "reactstrap";
import CompromisosTable from "./Compromisos.table";
import {
  successNotification,
  errorNotification
} from "../../../../../utils/notifications";

interface Props {
  periodo: string;
  idClub: number;
  trackingData: any;
  saveKey: number;
  puttingCompromisos: boolean;
  onSave: (periodo: string, idClub: number, compromisos: any) => Promise<any>;
  onReload: (periodo: string, idClub: number) => Promise<any>;
}

interface State {
  data: any | null;
  hasChanges: boolean;
  hasError: boolean;
}

export default class CompromisosComponent extends Component<Props, State> {
  state = {
    data: null,
    hasChanges: false,
    hasError: false
  };

  componentDidMount(): void {
    this.setState({
      data: this.props.trackingData
    });
  }

  componentDidUpdate(prevProps: Props) {
    if (
      this.props.trackingData &&
      this.props.trackingData !== prevProps.trackingData
    ) {
      this.setState({
        data: this.props.trackingData,
        hasChanges: false,
        hasError: false
      });
    }
  }

  handleUpdate = (data: any, hasError: boolean) => {
    this.setState({
      data,
      hasChanges: true,
      hasError
    });
  };

  handleGuardar = async () => {
    const { periodo, idClub } = this.props;
    const { data, hasError } = this.state;

    if (hasError) {
      errorNotification("Hay errores en los valores ingresados");
      return;
    }

    if (!periodo || !idClub) {
      errorNotification("No hay datos para guardar");
      return;
    }

    const compromisos = {
      consolidadoCompromiso: data.consolidadoCompromiso,
      numeroProspectosCompromiso: data.numeroProspectosCompromiso,
      totalVentasCompromiso: data.totalVentasCompromiso
    };

    const preview = await this.props.onSave(periodo, idClub, compromisos);

    if (preview.fulfilled) {
      successNotification("Compromisos guardados exitosamente");
      this.setState({ hasChanges: false });
      await this.props.onReload(periodo, idClub);
    } else {
      errorNotification(preview.puttingMembresiaTrackingCompromisosError);
    }
  };

  render() {
    const { data, hasChanges } = this.state;
    const { saveKey, puttingCompromisos } = this.props;

    if (!data) {
      return null;
    }

    return (
      <div>
        <h4 className="mb-3">Resumen de ventas mensuales</h4>
        <CompromisosTable
          data={data}
          onUpdate={this.handleUpdate}
          saveKey={saveKey}
        />

        <div className="mt-1 text-right">
          <Button
            color="secondary"
            onClick={this.handleGuardar}
            disabled={!hasChanges || puttingCompromisos}
            size="sm"
          >
            {puttingCompromisos ? "Guardando..." : "Guardar Compromisos"}
          </Button>
        </div>
      </div>
    );
  }
}
